import { render, staticRenderFns } from "./HeZhuOrder.vue?vue&type=template&id=5675b2ca&"
import script from "./HeZhuOrder.vue?vue&type=script&lang=js&"
export * from "./HeZhuOrder.vue?vue&type=script&lang=js&"
import style0 from "./HeZhuOrder.vue?vue&type=style&index=0&id=5675b2ca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports